"use client";

import posthog from "posthog-js";

let initializationStarted = false;

export function getExactDomainPostHogClient() {
  const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
  if (!posthogKey) return null;

  if (!posthog.__loaded && !initializationStarted) {
    initializationStarted = true;
    posthog.init(posthogKey, {
      api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://eu.i.posthog.com",
      ui_host: process.env.NEXT_PUBLIC_POSTHOG_UI_HOST || "https://eu.posthog.com",
      capture_pageview: false,
      // Keep duration and bounce metrics complete while pageviews are captured manually.
      capture_pageleave: true,
      cross_subdomain_cookie: false,
      disable_session_recording: true,
      persistence: "localStorage+cookie",
    });
  }

  return posthog;
}
